export default "__VITE_ASSET__4760baeb__"